import { createReducer, on } from '@ngrx/store'

import { ActionDefinition } from '@flowx/designer/modules/core/dictionary/process.dictionary'

import * as NodeActionActions from '../actions/node-action.actions'
import * as NodeEffectsActions from '../actions/node-effects.actions'
import * as ProcessEditorActions from '../actions/process-editor.actions'

export const nodeActionsFeatureKey = 'nodeActions'

export interface NodeActionsState {
  [nodeDefId: number]: ActionDefinition[]

  selected: number
}

export const initialState: NodeActionsState = {
  selected: null,
}

export const nodeActionsReducer = createReducer(
  initialState,
  on(ProcessEditorActions.setActions, (state, { nodeDefinitions }) => {
    const nodeActions = nodeDefinitions.reduce(
      (acc, nodeDefinition) => ({
        ...acc,
        [nodeDefinition.id]: nodeDefinition.actionDefinitions.reduce((_acc, action) => {
          _acc = [..._acc, action]
          if (action.callbackActions?.length) {
            _acc = [..._acc, ...action.callbackActions]
          }
          return _acc
        }, []),
      }),
      {}
    )
    return {
      ...state,
      ...nodeActions,
    }
  }),

  on(NodeActionActions.selectAction, (state, { actionId }) => ({
    ...state,
    selected: actionId,
  })),

  on(NodeEffectsActions.createNodeActionSuccess, (state, { nodeId, action }) => ({
    ...state,
    [nodeId]: [...state[nodeId], action],
    selected: action.id,
  })),

  on(NodeActionActions.updateActionSuccess, (state, { nodeId, action, oldAction }) => ({
    ...state,
    [nodeId]: state[nodeId].map((_action) => {
      if (action.id === _action.id) {
        return { ..._action, ...action }
      } else if (_action.parentFlowxUuid === oldAction.flowxUuid) {
        return { ..._action, parentFlowxUuid: action.flowxUuid }
      } else {
        return _action
      }
    }),
  })),
  on(NodeActionActions.deleteActionSuccess, (state, { nodeId, action }) => ({
    ...state,
    [nodeId]: state[nodeId].filter(
      (_action) => action.id !== _action.id && _action.parentFlowxUuid !== action.flowxUuid
    ),
  }))
)
